import { Component } from '@angular/core'

@Component({
  selector: 'app-risk-bag-icon',
  templateUrl: './risk-bag-icon.component.html',
  styleUrls: ['./risk-bag-icon.component.scss'],
  standalone: true,
  imports: []
})
export class RiskBagIconComponent {
  constructor() {}
}
